<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [noBow]="true"
      [canGoBack]="!cameFromReportAdded"
      [title]="report?.name === 'Overview' ? 'Dashboard Settings' : 'Report Settings'"
      [customBack]="report?.name === 'Overview' ? 'properties' : ('reports/' + report?.id)" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'desktop' }" />

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (report?.name !== 'Overview') {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'This is a'" /><span>&nbsp;</span>
          <tidy-text
            [body]="'<u>' + reportType + '</u>.'" /><span>&nbsp;</span>
            <tidy-text
              [body]="'This means'" /><span>&nbsp;</span>
              <tidy-text
                [body]="reportType" /><span>&nbsp;</span>
                <tidy-text
                  [body]="'will appear here. You can sort or filter'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="reportType" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="'by a given column.'" />
                  </tidy-row>
                }

                @if (report?.name !== 'Overview') {
                  <tidy-card>
                    <tidy-row [alignLastItemRight]="true">
                      <tidy-image
                        [src]="'assets/img/document.svg'"
                        class="header-size" />
                      <tidy-text
                        [header]="'Report Name'" />
                      <tidy-text
                        [body]="'Edit'"
                        class="link"
                        (action)="goToEditReportName()" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-text
                        [body]="report?.name" />
                    </tidy-row>
                  </tidy-card>
                }

                <tidy-row>
                  <tidy-text
                    [body]="'Columns'" />
                </tidy-row>

                <!--TODO add this for drag & drop
                <tidy-row [alignLastItemRight]="true">
                  <tidy-row [alignLastItemRight]="true" class="full-width">
                    <tidy-text
                      [header]="'Columns'">
                    </tidy-text>
                    <tidy-text
                      [body]="'Edit Order'">
                    </tidy-text>
                  </tidy-row>
                  <tidy-toggle [toggled]="editOrder" (toggleChanged)="editOrder = !editOrder" class="extra-left-margin"></tidy-toggle>
                </tidy-row>-->

                @for (field of report?.settings?.fields; track field) {
                  <tidy-card>
                    <tidy-row [alignLastItemRight]="true">
                      @if (editOrder) {
                        <tidy-image
                          class="header-size"
                          [src]="'assets/svg/menu-tidy-green.svg'" />
                      }
                      <tidy-text
                        [header]="field?.field_name" />
                      @if (!field?.is_field_visible) {
                        <tidy-text
                          style="margin-left:5px"
                          [body]="'(hidden)'" />
                      }
                      <tidy-text
                        [body]="'Edit'"
                        class="link"
                        (action)="goToEditReportColumn(field)" />
                    </tidy-row>
                    @if (!editOrder) {
                      @if (report?.settings?.sort_by_field_keys[0]?.field_key == field?.field_key) {
                        <tidy-row class="extra-top-padding">
                          <tidy-text
                            [helper]="'Sort column:'" />
                        </tidy-row>
                        <tidy-row class="vertical-align-center">
                          <tidy-image
                            [src]="report?.settings?.sort_by_field_keys[0]?.sort === 'asc' ? 'assets/svg/chevron-up-circle-outline.svg' : 'assets/svg/chevron-down-circle-outline.svg'"
                            class="body-size" />
                          <tidy-text
                [body]="(report?.settings?.sort_by_field_keys[0]?.sort === 'asc' ? ('Ascending' | translate) : ('Descending' | translate)) + (' order' | translate)" />
                        </tidy-row>
                      }
                      @for (filter of report?.settings?.filters; track filter) {
                        @if (filter?.dashboard_report_type_field_id == field?.dashboard_report_type_field_id) {
                          <tidy-row class="extra-top-padding">
                            <tidy-text
                              [helper]="'Filter column:'" />
                          </tidy-row>
                        }
                        @if (filter?.dashboard_report_type_field_id == field?.dashboard_report_type_field_id) {
                          <tidy-row class="vertical-align-center">
                            <tidy-image
                              [src]="'assets/svg/funnel-outline.svg'"
                              class="body-size" />
                            @if (field?.type !== 'date') {
                              <tidy-text
                                [body]="(filter?.operator | titlecase) + ': ' + (filter?.value | titlecase)" />
                            }
                            @if (field?.type === 'date') {
                              <tidy-text
                                [body]="'Date filter applied'" />
                            }
                          </tidy-row>
                        }
                      }
                    }
                  </tidy-card>
                }

                @if (cameFromReportAdded) {
                  <tidy-button
                    [action]="boundGoToReport"
                    [text]="'View Report'"
                    class="primary" />
                }

              </tidy-wrapper>
            </ng-template>

            @if (!isRightSideContent) {
              <app-scroll-wrapper [templateContent]="content" />
            }

            @if (isRightSideContent) {
              <ion-content class="ion-content-right-column">
                <ng-container *ngTemplateOutlet="content" />
              </ion-content>
            }
